export const setToken = ({accessToken}) => ({
    type: 'SET_TOKEN',
    accessToken
});

export const deleteToken = () => ({
    type: 'DELETE_TOKEN'
});